import { Box } from '@mui/material';

function MainTable() {
  return <Box>MainTable</Box>;
}

export default MainTable;
